import { Nullable } from '@application/Types/Opt'
import { Language, RequestQuoteData } from '@icontainers/widget'
import { Locale } from '@src/Application/Types/Locale'
import { openExternalUrl } from '@src/Application/Utils/BrowserUtils'
import { POPEYE_URL } from '@src/Core/Constants/RouteConstants'

type SetStickyWidget = (a: React.RefObject<HTMLDivElement>, b: boolean, c: (a: boolean) => void) => () => void

export const setStickyWidget: SetStickyWidget = (element, isMobile, setIsSticky) => () => {
    const { scrollY } = window
    if (element?.current && scrollY > element.current.offsetTop && !isMobile) {
        setIsSticky(true)
    } else {
        setIsSticky(false)
    }
}

type ResizeHandler = (setWidgetHeight: (a: number) => void, element: Nullable<HTMLElement>) => () => void

export const resizeHandler: ResizeHandler = (setWidgetHeight, element) => () => {
    element && setWidgetHeight(element.clientHeight)
}

const LANGUAGE_CODE = {
    EN: 'EN',
    ES: 'ES',
    DE: 'DE',
    NL: 'NL',
}

export type LanguageCode = typeof LANGUAGE_CODE[keyof typeof LANGUAGE_CODE]

export const MAP_LOCALE_TO_WIDGET_LANGUAGE: Record<Locale, Language> = {
    en: 'en',
    es: 'es',
    de: 'en',
    nl: 'en',
    ar: 'en',
}

export const mapLegacyContainerTypes = {
    DV20: 'dv20',
    DV40: 'dv40',
    DV40HC: 'hc40',
} as const

export type LegacyContainerType = keyof typeof mapLegacyContainerTypes

type HandleWidgetSearch = () => (quoteURL: string, data: RequestQuoteData) => void

export const handleWidgetSearch: HandleWidgetSearch = () => (quoteURL, data) => {
    const path = `${POPEYE_URL}/quotes${quoteURL}`

    openExternalUrl(path, false)
}
